import { appActionTypes } from '../app/app.constants';

import routes, { IRoute } from './routes';

export function routesReducer(state: IRoute[] = [], action: any) {
    const { type } = action;
    switch (type) {
        case appActionTypes.SET_CLIENT_CONFIG:
            const {
                presentationConfig: { showSections, sideBar },
            } = action;

            return routes
                .filter((route) => showSections[route.id])
                .map((route) => {
                    return { ...route, order: sideBar.indexOf(route.id) };
                })
                .sort((routeA, routeB) => {
                    return routeA.order - routeB.order;
                });
        default:
            return state;
    }
}
